// import React, { useEffect, useState } from 'react'
// import { useLocation } from 'react-router-dom';
// import { API } from '../../axios';
// import Sectorsbg from '../../Assets/Home/Sectorsbg.png'
// // Roads & Bridges
// import Roads1 from '../../Assets/Home/Roads1.png';
// import Roads2 from '../../Assets/Home/Roads2.png';
// import Roads3 from '../../Assets/Home/Roads3.png';
// import Roads4 from '../../Assets/Home/Roads4.png';
// import Roads5 from '../../Assets/Home/Roads5.png';
// import Roads6 from '../../Assets/Home/Roads6.png';
// import Roads7 from '../../Assets/Home/Roads7.png';

// // Tunnels
// import Tunnel1 from '../../Assets/Home/Tunnel1.png';
// import Tunnel2 from '../../Assets/Home/Tunnel2.png';
// import Tunnel3 from '../../Assets/Home/Tunnel3.png';
// import Tunnel4 from '../../Assets/Home/Tunnel4.png';
// import Tunnel5 from '../../Assets/Home/Tunnel5.png';
// import Tunnel6 from '../../Assets/Home/Tunnel6.png';

// // Urban Infrastructure
// // import Urban1 from '../../Assets/Home/Urban1.png';
// // import Urban2 from '../../Assets/Home/Urban2.png';
// import Urban3 from '../../Assets/Home/Urbaninfra3.png';
// import Urban4 from '../../Assets/Home/Urbaninfra4.png';
// import Urban5 from '../../Assets/Home/Urbaninfra5.png';
// import Urban6 from '../../Assets/Home/Urbaninfra6.png';

// // Transport Planning
// // import Transport1 from '../../Assets/Home/Transport1.png';
// // import Transport2 from '../../Assets/Home/Transport2.png';
// // import Transport3 from '../../Assets/Home/Transport3.png';
// // import Transport4 from '../../Assets/Home/Transport4.png';
// // import Transport5 from '../../Assets/Home/Transport5.png';
// // import Transport6 from '../../Assets/Home/Transport6.png';

// // Railway
// import Railway1 from '../../Assets/Home/Railway1.png';
// import Railway2 from '../../Assets/Home/Railway2.png';
// import Railway3 from '../../Assets/Home/Railway3.png';


// import highwayicon from '../../Assets/Home/highwayicon.svg'
// import bridgeicon from '../../Assets/Home/bridgeicon.svg'
// import ruralrods from '../../Assets/Home/ruralrods.svg'
// import RoadsArrows from '../../Assets/Home/RoadsArrows.png'

// const NewSectorDetails = () => {
//     const [SectorsData, setSectorsData] = useState([]);
//     const [selectedSector, setSelectedSector] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const location = useLocation();

//     const getSectorsData = async () => {
//         try {
//             const res = await API.get(`/website/sectorsdetail/`);
//             setSectorsData(res.data);
//             setLoading(false);
//         } catch (err) {
//             console.error('Failed to fetch sectors data', err);
//         }
//     };

//     useEffect(() => {
//         getSectorsData();
//     }, []);

//     const currentSector = location.pathname.slice(9).replace(/-/g, ' ');

//     useEffect(() => {
//         if (SectorsData.length > 0) {
//             const sector = SectorsData.find(item => item.name === currentSector);
//             if (sector) {
//                 setSelectedSector(sector);
//             } else {
//                 setLoading(false)
//                 setSelectedSector({ name: "No Data found for this Sector." })
//                 // setSelectedSector(SectorsData[0]);
//             }
//         }
//     }, [currentSector, SectorsData]);


//     // Default fallback images
//     const fallbackImages = [Roads1, Roads2, Roads3, Roads5, Roads6, Roads7];

//     const sectorImages = {
//         "Tunnels": [Tunnel1, Tunnel2, Tunnel3, Tunnel4, Tunnel5, Tunnel6],
//         "Roads & Bridges": [Roads1, Roads2, Roads3, Roads5, Roads6, Roads7],
//         "Metro": fallbackImages,
//         "Urban Infrastructure": [...fallbackImages.slice(0, 2), Urban3, Urban4, Urban5, Urban6],
//         "Railway": [Railway1, Railway2, Railway3, ...fallbackImages.slice(3)],
//         "Lab and Machinery": [...fallbackImages.slice(0, 2), Urban3, Urban4, Urban5, Urban6],
//         "Waterways": fallbackImages,
//         "Expressway": fallbackImages,
//     };
//     const selectedImages = sectorImages[selectedSector?.name] || [];


//     const data = ["2 million kilometres of roads with almost 960,000 kilometers of surfaced roads", "Fifty-three highways, almost 20,000 kilometers in length", "National highways carry about 40 percent of road traffic", "Around 60 percent of all passenger traffic travels by road."]
//     const data2 = [
//         {
//             icon: highwayicon,
//             title: "Highways & Expressways",
//             description: "We create high-performance highways and expressways that promote efficient movement of people and goods. We employ cutting-edge design principles and advanced materials to ensure safety, durability, and minimal environmental impact."
//         }, {
//             icon: bridgeicon,
//             title: "Bridges",
//             description: "Our bridge design expertise encompasses a broad spectrum, from elegant pedestrian bridges to complex multi-span structures. We prioritize aesthetics, functionality, and long-term sustainability, considering factors like traffic volume, seismic resilience, and ease of maintenance."
//         }, {
//             icon: ruralrods,
//             title: "Rural Roads",
//             description: "We recognize the unique challenges faced by rural communities in terms of accessibility and infrastructure development. Our team designs and implements rural road projects that improve connectivity to essential services, markets, and educational."
//         },
//     ]

//     const data3 = [
//         {
//             img: Roads5,
//             title: "NHAI",
//             servicetype: "Road Construction",
//         }, {
//             img: Roads6,
//             title: "PWD Haryana",
//             servicetype: "Super Vision",
//         }, {
//             img: Roads7,
//             title: "HSSIDC",
//             servicetype: "Authority Engineer",
//         },
//     ]

//     if (loading) {
//         return <div className='flex justify-center items-center h-[90vh] text-4xl darkblue font-semibold'>Loading...</div>;
//     }
//     else if (selectedImages.length === 0) {
//         return <div className='flex justify-center items-center h-[80vh] text-4xl darkblue font-semibold'>No data Available.</div>;
//     }

//     return (
//         <div className='flex flex-col gap-0'>
//             {/* 1st Section */}
//             <div className='flex flex-col gap-0 pb-16 md:py-16'>
//                 <div className='flex items-center justify-start w-full min-h-[18dvh] md:min-h-[35dvh] bg-no-repeat bg-cover bg-center' style={{ backgroundImage: `url(${Sectorsbg})` }}>
//                     {/* <p className='text-4xl md:text-7xl text-white px-4 py-4 md:px-14 font-semibold'>{selectedSector?.name === "Waterways" ? "Hydro Projects" : selectedSector?.name}</p> */}
//                 </div>
//                 <div className='relative flex flex-col px-4 md:px-14 pt-10'>
//                     <p className='text-5xl md:text-8xl tracking-wider uppercase font-semibold md:font-bold text-[#F4F4F4]'>About</p>
//                     <p className='text-2xl md:text-5xl purple font-semibold -mt-6 md:-mt-10'>{selectedSector?.name === "Waterways" ? "Hydro Projects" : selectedSector?.name}</p>
//                 </div>
//                 <div className='flex flex-col md:flex-row gap-2 md:py-10 py-6 '>
//                     <div className='md:w-[100%] flex items-center justify-between md:justify-start md:gap-8 px-4 md:px-14'>
//                         <img src={selectedImages[0]} alt="" className='w-[42%] md:w-[30%] rounded-md  sector-img' />
//                         <div className='hidden md:flex flex-col items-center gap-4 font-semibold'>
//                             <div className='w-full flex items-center justify-between'>
//                                 <p>Route Evaluation</p>
//                                 <p>Traffic Control</p>
//                             </div>
//                             <img src={RoadsArrows} alt="" />
//                             <p>Safety Planning</p>
//                         </div>
//                         <img src={selectedImages[1]} alt="" className='w-[42%] md:w-[30%] rounded-md  sector-img' />
//                     </div>
//                 </div>
//                 <div className='md:w-[95%] px-4 md:px-14'>
//                     <p dangerouslySetInnerHTML={{ __html: selectedSector?.description?.replace(/CivilMantra/g, 'Saptagon') }} />
//                 </div>
//             </div>
//             {/* 2nd Section */}
//             <div className='flex flex-col items-start gap-8 px-4 md:px-14 py-10 md:py-16 bg-[#f3f0f9]'>
//                 <p className='text-2xl md:text-3xl font-semibold text-black'>The staggering statistics tells it all</p>
//                 <div className='w-full flex flex-col flex-wrap gap-4'>
//                     {data.map((item, i) => (
//                         <p className='flex-1 p-4 md:px-6 leading-snug rounded-md md:text-lg font-semibold cursor-pointer bg-[#EDEAF3] hover:bg-[#DCD4EE] hover:text-black text-black md:darkgray duration-300'>{item}</p>
//                     ))}
//                 </div>
//             </div>
//             {/* 3rd Section */}
//             <div className='relative flex flex-col items-start gap-14 px-4 md:px-14 py-0 md:py-16'>
//                 <div className='flex flex-col gap-0 items-start pb-20'>
//                     <div className='relative flex flex-col pt-10'>
//                         <p className='text-5xl md:text-8xl tracking-wider uppercase font-semibold md:font-bold text-[#F4F4F4]'>Development</p>
//                         <p className='text-2xl md:text-5xl purple font-semibold -mt-6 md:-mt-10'>{selectedSector?.name === "Waterways" ? "Hydro Projects" : selectedSector?.name}</p>
//                     </div>
//                     <div className='flex flex-col md:flex-row items-center justify-around gap-4 md:gap-0 pt-10 md:pt-20'>
//                         <img src={selectedImages[2]} alt="" className='w-[80%] md:w-[22%]' />
//                         <p className='md:w-[50%] md:text-xl text-justify md:text-left'>
//                             In addition, providing access to employment, social, health and education services
//                             makes a road network crucial in fighting against poverty. As per the National Highways
//                             Authority of India, about 65% of freight and 80% passenger traffic is carried by the roads. <br /><br />
//                             As India continues its forward march as a global economic power, her urban transport network
//                             is fast becoming the most important infra-structure to support its mega growth.
//                         </p>
//                     </div>

//                     <div className='relative flex flex-col pt-10 md:pt-20'>
//                         <p className='text-5xl md:text-8xl tracking-wider uppercase font-semibold md:font-bold text-[#F4F4F4]'>Providing</p>
//                         <p className='text-2xl md:text-5xl purple font-semibold -mt-6 md:-mt-10'>Best Services</p>
//                     </div>
//                     <div className='w-full min-h-[40dvh] md:min-h-[65dvh] bg-cover flex flex-col items-center bg-no-repeat bg-center mt-10' style={{ backgroundImage: `url(${Roads4})` }}>
//                         <div className='flex flex-col items-center gap-4 md:gap-10 md:w-[50%] md:pt-20 md:text-center'>
//                             <p className='text-2xl md:text-3xl font-semibold'>Building Enduring Connections: Roads & Bridges</p>
//                             <p className='md:w-[85%] darkgray md:text-lg text-justify md:text-left font-normal'>
//                                 At Saptagon, we understand the critical role that roads and bridges play in connecting communities,
//                                 facilitating trade, and driving economic prosperity. Our team of skilled engineers and experienced
//                                 project managers works collaboratively with clients to design, construct, and supervise the development of:
//                             </p>
//                         </div>
//                     </div>
//                     <div className='w-full grid  gap-10 md:gap-32 md:grid-cols-3 grid-cols-1'>
//                         {data2.map((item, i) => (
//                             <div className='group border-[1px] hover:shadow-2xl shadow-md hover:-translate-y-3  flex flex-col items-center justify-center gap-6 px-6 py-6 md:py-10 text-center rounded-md text-black hover:bg-[#8364C3] duration-300 cursor-pointer'>
//                                 <img src={item.icon} alt={item.title} className='border-2 p-3 bg-transparent w-28 h-28 rounded-full' />
//                                 <p className='group-hover:text-white font-semibold text-2xl md:text-lg'>{item.title}</p>
//                                 <p className='group-hover:text-white md:darkgray leading-snug'>{item.description}</p>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>

//             {/* 4th Section */}
//             <div className='w-full flex flex-col items-start gap-8 py-10 pb-40 px-4 md:px-14 bg-[#f3f0f9]'>
//                 <div className='relative flex flex-col'>
//                     <p className='text-5xl md:text-8xl tracking-wider uppercase font-semibold md:font-bold text-[#ebebeb]'>Our Latest</p>
//                     <p className='text-2xl md:text-5xl purple font-semibold -mt-6 md:-mt-10'>Projects</p>
//                 </div>
//                 <div className='flex flex-col md:flex-row items-center gap-20 md:gap-10 pt-6 md:pt-10'>
//                     {data3.map((item, i) => (
//                         <div className='relative flex flex-col items-center hover:scale-105 duration-300 cursor-default'>
//                             <img src={selectedImages[i + 3]} alt={item.title} className='w-full  duration-300' />
//                             <div className={`absolute top-[85%] p-4 bg-[#8364C3] text-white rounded-sm flex flex-col items-center gap-1 shadow-lg ${i % 2 !== 0 ? "top-[72.2%] w-[100%] " : "top-[80%] w-[100%]"}`}>
//                                 <p className='font-semibold'>{item.title}</p>
//                                 <p>{item.servicetype}</p>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//             {/* Get in touch */}
//             {/* <Getintouch /> */}
//         </div>
//     )
// }



import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { API } from '../../axios';
import Sectorsbg from '../../Assets/Home/Sectorsbg.png'
// Roads & Bridges
import Roads1 from '../../Assets/Home/Roads1.png';
import Roads2 from '../../Assets/Home/Roads2.png';
import Roads3 from '../../Assets/Home/Roads3.png';
import Roads4 from '../../Assets/Home/Roads4.png';
import Roads5 from '../../Assets/Home/Roads5.png';
import Roads6 from '../../Assets/Home/Roads6.png';
import Roads7 from '../../Assets/Home/Roads7.png';

// Tunnels
import Tunnel1 from '../../Assets/Home/Tunnel1.png';
import Tunnel2 from '../../Assets/Home/Tunnel2.png';
import Tunnel3 from '../../Assets/Home/Tunnel3.png';
import Tunnel4 from '../../Assets/Home/Tunnel4.png';
import Tunnel5 from '../../Assets/Home/Tunnel5.png';
import Tunnel6 from '../../Assets/Home/Tunnel6.png';

// Urban Infrastructure
import Urban3 from '../../Assets/Home/Urbaninfra3.png';
import Urban4 from '../../Assets/Home/Urbaninfra4.png';
import Urban5 from '../../Assets/Home/Urbaninfra5.png';
import Urban6 from '../../Assets/Home/Urbaninfra6.png';

// Railway
import Railway1 from '../../Assets/Home/Railway1.png';
import Railway2 from '../../Assets/Home/Railway2.png';
import Railway3 from '../../Assets/Home/Railway3.png';

import highwayicon from '../../Assets/Home/highwayicon.svg'
import bridgeicon from '../../Assets/Home/bridgeicon.svg'
import ruralrods from '../../Assets/Home/ruralrods.svg'
import RoadsArrows from '../../Assets/Home/RoadsArrows.png'

const NewSectorDetails = () => {
    const [SectorsData, setSectorsData] = useState([]);
    const [selectedSector, setSelectedSector] = useState(null);
    const [loading, setLoading] = useState(true);
    const [imageErrors, setImageErrors] = useState({});
    const location = useLocation();

    const getSectorsData = async () => {
        try {
            const res = await API.get(`/website/sectorsdetail/`);
            console.log('API Response:', res.data);
            setSectorsData(res.data);
            setLoading(false);
        } catch (err) {
            console.error('Failed to fetch sectors data', err);
            setLoading(false);
        }
    };

    useEffect(() => {
        getSectorsData();
    }, []);

    const currentSector = location.pathname.slice(9).replace(/-/g, ' ');
    console.log('Current Sector:', currentSector);

    useEffect(() => {
        if (SectorsData.length > 0) {
            console.log(SectorsData, 'sectordata')
            const sector = SectorsData.find(item => item.name === currentSector);
            console.log('Found Sector:', sector);
            if (sector) {
                setSelectedSector(sector);
            } else {
                setLoading(false);
                setSelectedSector({ name: "No Data found for this Sector." });
            }
        }
    }, [currentSector, SectorsData]);

    // Default fallback images
    const fallbackImages = [Roads1, Roads2, Roads3, Roads5, Roads6, Roads7];

    const sectorImages = {
        "Tunnels": [Tunnel1, Tunnel2, Tunnel3, Tunnel4, Tunnel5, Tunnel6],
        "Roads & Bridges": [Roads1, Roads2, Roads3, Roads5, Roads6, Roads7],
        "Metro": fallbackImages,
        "Urban Infrastructure": [...fallbackImages.slice(0, 2), Urban3, Urban4, Urban5, Urban6],
        "Railway": [Railway1, Railway2, Railway3, ...fallbackImages.slice(3)],
        "Lab and Machinery": [Roads1, Roads2, Roads3, Roads5, Roads6, Roads7],
        "Waterways": fallbackImages,
        "Expressway": fallbackImages,
    };

    // Get images from backend first, fallback to default images
    // const getSectorImages = () => {
    //     if (!selectedSector) return [];

    //     // Try to use backend images first
    //     const backendImages = [];

    //     // Check for pic1
    //     if (selectedSector.pic1 && selectedSector.pic1 !== 'null' && selectedSector.pic1 !== null && selectedSector.pic1 !== '') {
    //         backendImages.push(selectedSector.pic1);
    //     }
    //     // Check for pic2
    //     if (selectedSector.pic2 && selectedSector.pic2 !== 'null' && selectedSector.pic2 !== null && selectedSector.pic2 !== '') {
    //         backendImages.push(selectedSector.pic2);
    //     }
    //     // Check for pic3
    //     if (selectedSector.pic3 && selectedSector.pic3 !== 'null' && selectedSector.pic3 !== null && selectedSector.pic3 !== '') {
    //         backendImages.push(selectedSector.pic3);
    //     }

    //     console.log('Backend Images:', backendImages);

    //     // If we have backend images, use them and pad to 6 images
    //     if (backendImages.length > 0) {
    //         const paddedImages = [...backendImages];
    //         while (paddedImages.length < 6) {
    //             paddedImages.push(fallbackImages[paddedImages.length % fallbackImages.length]);
    //         }
    //         return paddedImages;
    //     }

    //     // Otherwise use sector-specific fallback images
    //     return sectorImages[selectedSector.name] || fallbackImages;
    // };
    const getSectorImages = () => {
        if (!selectedSector) return fallbackImages;

        const backendImages = [
            selectedSector.pic1,
            selectedSector.pic2,
            selectedSector.pic3
        ].filter(img => img && img !== "null");

        if (backendImages.length > 0) {
            return [...backendImages, ...fallbackImages].slice(0, 6);
        }

        return sectorImages[selectedSector.name] || fallbackImages;
    };
    const selectedImages = getSectorImages();
    console.log('Selected Images:', selectedImages);

    // Enhanced description formatter
    // const formatDescription = (description) => {
    //     if (!description) return '';

    //     console.log('Original Description:', description);

    //     let formatted = description;

    //     // Method 1: Remove all backslashes
    //     formatted = formatted.replace(/\\/g, '');

    //     // Method 2: Handle specific escaped patterns
    //     formatted = formatted.replace(/\\"/g, '"');
    //     formatted = formatted.replace(/\\'/g, "'");

    //     // Method 3: If it's still not working, try to parse as JSON string
    //     try {
    //         // Check if the string might be JSON encoded
    //         if (formatted.startsWith('"') && formatted.endsWith('"')) {
    //             const parsed = JSON.parse(formatted);
    //             formatted = parsed;
    //         }
    //     } catch (e) {
    //         // If parsing fails, continue with current formatted string
    //         console.log('Not a JSON string, continuing with replacement');
    //     }

    //     // Replace CivilMantra with Saptagon
    //     formatted = formatted.replace(/CivilMantra/g, 'Saptagon');

    //     // Fix any broken HTML tags (remove extra quotes)
    //     formatted = formatted.replace(/style=\\"/g, 'style="');
    //     formatted = formatted.replace(/style=\\\\"/g, 'style="');

    //     console.log('Formatted Description:', formatted);

    //     return formatted;
    // };


    const formatDescription = (description) => {
        if (!description) return "";

        let formatted = description;

        // remove escaped quotes
        formatted = formatted.replace(/\\"/g, '"');

        // remove double backslashes
        formatted = formatted.replace(/\\\\/g, "\\");

        // replace company name
        formatted = formatted.replace(/CivilMantra/g, "Saptagon");

        return formatted;
    };

    const handleImageError = (index, fallbackSrc) => {
        console.log(`Image ${index} failed to load`);
        setImageErrors(prev => ({
            ...prev,
            [index]: true
        }));
    };

    const data = [
        "2 million kilometres of roads with almost 960,000 kilometers of surfaced roads",
        "Fifty-three highways, almost 20,000 kilometers in length",
        "National highways carry about 40 percent of road traffic",
        "Around 60 percent of all passenger traffic travels by road."
    ];

    const data2 = [
        {
            icon: highwayicon,
            title: "Highways & Expressways",
            description: "We create high-performance highways and expressways that promote efficient movement of people and goods. We employ cutting-edge design principles and advanced materials to ensure safety, durability, and minimal environmental impact."
        }, {
            icon: bridgeicon,
            title: "Bridges",
            description: "Our bridge design expertise encompasses a broad spectrum, from elegant pedestrian bridges to complex multi-span structures. We prioritize aesthetics, functionality, and long-term sustainability, considering factors like traffic volume, seismic resilience, and ease of maintenance."
        }, {
            icon: ruralrods,
            title: "Rural Roads",
            description: "We recognize the unique challenges faced by rural communities in terms of accessibility and infrastructure development. Our team designs and implements rural road projects that improve connectivity to essential services, markets, and educational."
        },
    ];

    const data3 = [
        {
            img: Roads5,
            title: "NHAI",
            servicetype: "Road Construction",
        }, {
            img: Roads6,
            title: "PWD Haryana",
            servicetype: "Super Vision",
        }, {
            img: Roads7,
            title: "HSSIDC",
            servicetype: "Authority Engineer",
        },
    ];

    if (loading) {
        return <div className='flex justify-center items-center h-[90vh] text-4xl darkblue font-semibold'>Loading...</div>;
    }

    if (!selectedSector || selectedSector.name === "No Data found for this Sector.") {
        return <div className='flex justify-center items-center h-[80vh] text-4xl darkblue font-semibold'>No data Available.</div>;
    }

    return (
        <div className='flex flex-col gap-0'>
            {/* 1st Section */}
            <div className='flex flex-col gap-0 pb-16 md:py-16'>
                <div className='flex items-center justify-start w-full min-h-[18dvh] md:min-h-[35dvh] bg-no-repeat bg-cover bg-center' style={{ backgroundImage: `url(${Sectorsbg})` }}>
                </div>
                <div className='relative flex flex-col px-4 md:px-14 pt-10'>
                    <p className='text-5xl md:text-8xl tracking-wider uppercase font-semibold md:font-bold text-[#F4F4F4]'>About</p>
                    <p className='text-2xl md:text-5xl purple font-semibold -mt-6 md:-mt-10'>{selectedSector?.name === "Waterways" ? "Hydro Projects" : selectedSector?.name}</p>
                </div>
                <div className='flex flex-col md:flex-row gap-2 md:py-10 py-6 '>
                    <div className={currentSector != "Lab and Machinery" ? 'md:w-[100%] flex items-center justify-between md:justify-start md:gap-8 px-4 md:px-14' : 'md:w-[100%] flex items-center justify-around md:justify-around px-4 md:px-14'}>
                        {selectedImages[0] && !imageErrors[0] && (
                            <img
                                src={selectedImages[0]}
                                alt="Sector 1"
                                className='w-[42%] md:w-[30%] rounded-md sector-img object-cover'
                                onError={(e) => {
                                    handleImageError(0, Roads1);
                                    e.currentTarget.src = Roads1;
                                }}
                            />
                        )}
                        {imageErrors[0] && (
                            <img src={Roads1} alt="Fallback 1" className='w-[42%] md:w-[30%] rounded-md sector-img object-cover' />
                        )}
                        {currentSector != "Lab and Machinery" && <div className='hidden md:flex flex-col items-center gap-4 font-semibold'>
                            <div className='w-full flex items-center justify-between'>
                                <p>Route Evaluation</p>
                                <p>Traffic Control</p>
                            </div>
                            <img src={RoadsArrows} alt="" />
                            <p>Safety Planning</p>
                        </div>}
                        {selectedImages[1] && !imageErrors[1] && (
                            <img
                                src={selectedImages[1]}
                                alt="Sector 2"
                                className='w-[42%] md:w-[30%] rounded-md sector-img object-cover'
                                onError={(e) => {
                                    handleImageError(1, Roads2);
                                    e.currentTarget.src = Roads2;
                                }}
                            />
                        )}
                        {imageErrors[1] && (
                            <img src={Roads2} alt="Fallback 2" className='w-[42%] md:w-[30%] rounded-md sector-img object-cover' />
                        )}
                    </div>
                </div>
                <div className='md:w-[95%] px-4 md:px-14'>
                    {console.log(selectedSector)}
                    {selectedSector?.description ? (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: formatDescription(selectedSector?.description)
                            }}
                        />
                    ) : (
                        <p>No description available for this sector.</p>
                    )}
                </div>
            </div>

            {/* 2nd Section */}
            <div className='flex flex-col items-start gap-8 px-4 md:px-14 py-10 md:py-16 bg-[#f3f0f9]'>
                <p className='text-2xl md:text-3xl font-semibold text-black'>The staggering statistics tells it all</p>
                <div className='w-full flex flex-col flex-wrap gap-4'>
                    {data.map((item, i) => (
                        <p key={i} className='flex-1 p-4 md:px-6 leading-snug rounded-md md:text-lg font-semibold cursor-pointer bg-[#EDEAF3] hover:bg-[#DCD4EE] hover:text-black text-black md:darkgray duration-300'>{item}</p>
                    ))}
                </div>
            </div>

            {/* 3rd Section */}
            <div className='relative flex flex-col items-start gap-14 px-4 md:px-14 py-0 md:py-16'>
                <div className='flex flex-col gap-0 items-start pb-20'>
                    <div className='relative flex flex-col pt-10'>
                        <p className='text-5xl md:text-8xl tracking-wider uppercase font-semibold md:font-bold text-[#F4F4F4]'>Development</p>
                        <p className='text-2xl md:text-5xl purple font-semibold -mt-6 md:-mt-10'>{selectedSector?.name === "Waterways" ? "Hydro Projects" : selectedSector?.name}</p>
                    </div>
                    <div className='flex flex-col md:flex-row items-center justify-around gap-4 md:gap-0 pt-10 md:pt-20'>
                        {selectedImages[2] && !imageErrors[2] && (
                            <img
                                src={selectedImages[2]}
                                alt="Sector 3"
                                className='w-[80%] md:w-[22%] object-cover'
                                onError={(e) => {
                                    handleImageError(2, Roads3);
                                    e.currentTarget.src = Roads3;
                                }}
                            />
                        )}
                        {imageErrors[2] && (
                            <img src={Roads3} alt="Fallback 3" className='w-[80%] md:w-[22%] object-cover' />
                        )}
                        <p className='md:w-[50%] md:text-xl text-justify md:text-left'>
                            In addition, providing access to employment, social, health and education services
                            makes a road network crucial in fighting against poverty. As per the National Highways
                            Authority of India, about 65% of freight and 80% passenger traffic is carried by the roads. <br /><br />
                            As India continues its forward march as a global economic power, her urban transport network
                            is fast becoming the most important infra-structure to support its mega growth.
                        </p>
                    </div>

                    <div className='relative flex flex-col pt-10 md:pt-20'>
                        <p className='text-5xl md:text-8xl tracking-wider uppercase font-semibold md:font-bold text-[#F4F4F4]'>Providing</p>
                        <p className='text-2xl md:text-5xl purple font-semibold -mt-6 md:-mt-10'>Best Services</p>
                    </div>
                    <div className='w-full min-h-[40dvh] md:min-h-[65dvh] bg-cover flex flex-col items-center bg-no-repeat bg-center mt-10' style={{ backgroundImage: `url(${Roads4})` }}>
                        <div className='flex flex-col items-center gap-4 md:gap-10 md:w-[50%] md:pt-20 md:text-center'>
                            <p className='text-2xl md:text-3xl font-semibold'>Building Enduring Connections: Roads & Bridges</p>
                            <p className='md:w-[85%] darkgray md:text-lg text-justify md:text-left font-normal'>
                                At Saptagon, we understand the critical role that roads and bridges play in connecting communities,
                                facilitating trade, and driving economic prosperity. Our team of skilled engineers and experienced
                                project managers works collaboratively with clients to design, construct, and supervise the development of:
                            </p>
                        </div>
                    </div>
                    <div className='w-full grid gap-10 md:gap-32 md:grid-cols-3 grid-cols-1'>
                        {data2.map((item, i) => (
                            <div key={i} className='group border-[1px] hover:shadow-2xl shadow-md hover:-translate-y-3 flex flex-col items-center justify-center gap-6 px-6 py-6 md:py-10 text-center rounded-md text-black hover:bg-[#8364C3] duration-300 cursor-pointer'>
                                <img src={item.icon} alt={item.title} className='border-2 p-3 bg-transparent w-28 h-28 rounded-full' />
                                <p className='group-hover:text-white font-semibold text-2xl md:text-lg'>{item.title}</p>
                                <p className='group-hover:text-white md:darkgray leading-snug'>{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* 4th Section */}
            <div className='w-full flex flex-col items-start gap-8 py-10 pb-40 px-4 md:px-14 bg-[#f3f0f9]'>
                <div className='relative flex flex-col'>
                    <p className='text-5xl md:text-8xl tracking-wider uppercase font-semibold md:font-bold text-[#ebebeb]'>Our Latest</p>
                    <p className='text-2xl md:text-5xl purple font-semibold -mt-6 md:-mt-10'>Projects</p>
                </div>
                <div className='flex flex-col md:flex-row items-center gap-20 md:gap-10 pt-6 md:pt-10'>
                    {data3.map((item, i) => {
                        const imageIndex = i + 3;
                        const imageSrc = selectedImages[imageIndex] || item.img;
                        const hasError = imageErrors[imageIndex];

                        return (
                            <div key={i} className='relative flex flex-col items-center hover:scale-105 duration-300 cursor-default w-full md:w-1/3'>
                                <div className='relative w-full aspect-[4/3] overflow-hidden'>
                                    {!hasError ? (
                                        <img
                                            src={imageSrc}
                                            alt={item.title}
                                            className='w-full h-full duration-300 object-cover'
                                            onError={(e) => {
                                                handleImageError(imageIndex, item.img);
                                                e.currentTarget.src = item.img;
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                            className='w-full h-full duration-300 object-cover'
                                        />
                                    )}
                                </div>
                                <div className={`absolute left-0 right-0 p-4 bg-[#8364C3] text-white rounded-sm flex flex-col items-center gap-1 shadow-lg mx-auto w-[90%] ${i % 2 !== 0 ? "bottom-[-20%]" : "bottom-[-25%]"
                                    }`}>
                                    <p className='font-semibold text-center'>{item.title}</p>
                                    <p className='text-center text-sm'>{item.servicetype}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}

export default NewSectorDetails